import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=89262242&scoped=true&"
import script from "./BannerList.vue?vue&type=script&lang=js&"
export * from "./BannerList.vue?vue&type=script&lang=js&"
import style0 from "./BannerList.vue?vue&type=style&index=0&id=89262242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89262242",
  null
  
)

export default component.exports